<script>
import {
  CdrSkeleton,
  CdrSkeletonBone,
} from '@rei/cedar';

export default {
  name: 'HeadingLoader',
  components: {
    CdrSkeleton,
    CdrSkeletonBone,
  },
};
</script>
<template>
  <cdr-skeleton>
    <cdr-skeleton-bone type="heading" />
  </cdr-skeleton>
</template>
